import React, { useMemo } from "react";
import { InsWidgetIcons } from "components/widgets/icons/insWidgetIcons";
import { AuxTargetAtrEnum } from "@blk/aladdin-web-components";
const parseSubtitle = (subtitle) => {
    const matchData = subtitle.split(",").reduce((acc, pair) => {
        const re = /^\[(?<key>[^\]]+)\](?<value>.*)$/u;
        const match = re.exec(pair);
        if (match?.groups) {
            const key = match.groups.key.trim();
            const value = match.groups.value.trim();
            if (key) {
                acc[key] = value;
            }
        }
        return acc;
    }, {});
    return matchData;
};
export const InsStackedColumnChartSubtitle = ({ subtitle }) => {
    const matchData = useMemo(() => parseSubtitle(subtitle), [subtitle]);
    return (React.createElement("div", { className: "ins-stacked-column-chart-subtitle" },
        matchData?.icon && React.createElement(InsWidgetIcons, { src: matchData.icon }),
        matchData.link
            ? React.createElement("a", { href: matchData.link, target: AuxTargetAtrEnum.BLANK, rel: "noopener noreferrer" }, matchData?.label)
            : matchData?.label ?? "",
        matchData?.date && React.createElement("span", { className: "ins-stacked-column-chart-subtitle-date" },
            "as at ",
            matchData.date)));
};
